<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm > 
        <v-layout row wrap>
            <v-flex xs8>
                
            </v-flex>
            <v-flex xs4>
                <CountDown />
            </v-flex>
        </v-layout> 
    <div v-if="needInit">{{initData()}}</div>  
       <v-layout row wrap>
            <v-flex xs6> <v-card class="shadow-none" outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <c-type1 v-bind:ltype="1"></c-type1>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card class="shadow-none" outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <c-type1 v-bind:ltype="2"></c-type1>
            </v-card>  </v-flex>
            <v-flex xs12>
                <v-card class="shadow-none" outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-card class="shadow-none" flat>
                            <v-btn>Show</v-btn>
                        </v-card>
                        <v-card outlined class="shadow-none">
                            <v-btn v-if="showSaveButton && (getCountdownStatus.count > 0 || getCountdownStatus.count == -100)" @click="saveAndClose">Save and close</v-btn>
                            <v-btn @click="closeForm">Close without saving</v-btn>                    
                        </v-card>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import CType1  from '../CType1.vue'
import LanguageList from '../LanguageList.vue'
import {mapGetters} from 'vuex'
import CountDown from '../../../components/misc/CountDown.vue'
import axios from '../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             content1: null,
             needInit : true,
             ID: 0,
             order: 0,
             lessonID: 0,
             showSaveButton: true
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContent1',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig',
                        'getCountdownStatus'
                    ])
    ,
    components: {
        CType1 : CType1,
        LanguageList,
        CountDown
    },
    beforeDestroy() {
        const data = { task_id: this.ID}
        axios.post('/unlock', data, this.getAxiosConfig)
        .then(() => {                
        })
        .catch(() => {
        })
    },
    methods : {
        prepareDataforSave() {
            this.runSaving = true
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {            
            this.runSaving = false
            // upratat celok pre json
            const data = this.getAllContent1 
           
            this.content1 = {
                lesson_id: this.lessonID,
                task_id : this.ID,
                task_order : this.order,
                task_type_id : 1,
                max_score : '0',
                globals : '',
                content_list: []
            }
            
            for(var key in data) {
                this.content1.content_list.push( {
                    lang_id : key.replace('l',''),
                    content : data[key]
                })
            }

            // console.log(this.content1)
            // axios
            axios.post('/create-edit-task-all-lang', this.content1, this.getAxiosConfig)
            .then(() => {                
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },

        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'lesson_admin_content', params: {id: this.lessonID}})
        },
        initData() {
            this.needInit = false
            // console.log(this.$route.params.id)
            this.$store.commit('setCountdownStatus', { id: this.$route.params.id, count: 1800, max: 1800})

            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)
            
            this.ID = this.$route.params.id
            this.lessonID = this.$route.params.lesson_id

            if ( this.ID == '0') {
                this.$store.commit('prepareContent1')
                this.$store.dispatch('createEmptyAdminBreadCrumbs',this.lessonID)
            } else {
                axios.get('/get-task-in-all-lang/' + this.ID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    this.$store.dispatch('setAdminBreadCrumbs',res.data)

                    for(var i = 0; i < res.data.list.length; i++) {
                        this.$store.commit('setContent1', res.data.list[i]) 
                    }
                    if (res.data.islocked) {
                        this.showSaveButton = false
                        this.$store.commit('setFeedback', 'The content is locked by another user, you can only read or wait 30 minutes.')    
                    }

                    this.order = res.data.task_order
                    this.lessonID = res.data.lesson_id
                    
                    // init data to editor
                    this.$store.commit('setInitData1',true)
                    this.$store.commit('setInitData2',true)
                    
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            }
        } 
    },
    
    mounted() {        
        this.needInit = true
    }  
}
</script>


